import React from "react";
import {client, getArticle } from "../api.js"
import CreateArticlePage from "../Component/CreateArticlePage";
import { useState } from "react";
import { useEffect } from "react";

const CreateArticlePageContainer = () => {

    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        authorId: "",
        id: "",
        rating: 0,
        title: ""
    })

    const handleChangeFormData = (label, newValue) => {
        setFormData({
            ...formData,
            [label]: newValue
        })
    }

    useEffect(()=> {
        getArticle()
            .then((res)=> {
                setArticles(res);
                setLoading(false);
            })
            .catch((err)=>{
                console.log(err);
            });
    }, [loading]);

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        const articleLocation = articles.findIndex((article) => article.id === +formData.id);
        const id = formData.id;
        if(articleLocation >= 0){
            await client.put(id, {
                author_id: formData.authorId,
                rating: formData.rating,
                title: formData.title
            });
        } else {
            await client.post("/", {
                author_id: formData.authorId,
                id: formData.id,
                rating: formData.rating,
                title: formData.title
            });
        }
        setLoading(true);
    }

    return(
        <CreateArticlePage articles={articles} 
                            loading={loading}
                            formData={formData}
                            handleChangeFormData={handleChangeFormData}
                            handleSubmit={handleSubmit}/>
    );
}

export default CreateArticlePageContainer;